/** @jsx jsx */

import { jsx, css } from '@emotion/core';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableTd,
  TableTh,
  Text,
} from '@zapier/design-system';

import { VerbAnalytics } from './types';

type Props = {
  items: VerbAnalytics[];
  type: 'Action' | 'Trigger';
};

const Styles = {
  tableContainer: css`
    & th,
    & td {
      background-color: inherit !important;
    }
  `,
};

const AnalyticsTable = ({ items, type }: Props) => {
  const getTableCellHeader = (label, alignRight = true) => (
    <TableTh>
      <Text tag="h6" textAlign={alignRight ? 'right' : 'inherit'}>
        {label}
      </Text>
    </TableTh>
  );

  const getTableCellBody = (label, alignRight = true) => (
    <TableTd>
      <Text tag="p" textAlign={alignRight ? 'right' : 'inherit'}>
        {label}
      </Text>
    </TableTd>
  );
  return (
    <div css={Styles.tableContainer}>
      <Table>
        <TableHead>
          <TableRow>
            {getTableCellHeader(type, false)}
            {getTableCellHeader('Live Zap workflows')}
            {getTableCellHeader('Paused Zap workflows')}
            {getTableCellHeader('Total Zap workflows')}
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map(({ name, zapsLive, zapsPaused, zapsTotal }) => {
            return (
              <TableRow key={name}>
                {getTableCellBody(name, false)}
                {getTableCellBody(zapsLive.toLocaleString())}
                {getTableCellBody(zapsPaused.toLocaleString())}
                {getTableCellBody(zapsTotal.toLocaleString())}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
};

export default AnalyticsTable;
